import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseListReview } from 'entities/Review/api/types'

export class ReviewRow extends RowBase<IResponseListReview> {
  constructor(origin: IResponseListReview) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get rating() {
    return this.origin.rating
  }

  get happy_count() {
    return this.origin.happy_count
  }

  get unhappy_count() {
    return this.origin.unhappy_count
  }

  get short_url() {
    return this.origin.short_url
  }
}
